import angular from 'angular';
import uiRouter from 'angular-ui-router';
import groupComponent from './group.component';
import groupListComponent from './group-list.component';
import groupDetailComponent from './group-detail.component';
import groupService from './group.service';
import moduleService from './module.service';

let groupModule = angular.module('group', [
  uiRouter
])

.service('Module', moduleService)
.service('Group', groupService)

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/group');

  $stateProvider
    .state('group', {
      component: 'group'
    })
    .state('group.list', {
      url: '/group',
      component: 'groupList'
    })
    .state('group.create', {
      url: '/group/new',
      component: 'groupDetail',
      params: {
      	id: ""
      }
    })
    .state('group.edit', {
      url: '/group/:id/edit',
      component: 'groupDetail',
      params: {
        id: ""
      }
    });
})

.component('group', groupComponent)
.component('groupList', groupListComponent)
.component('groupDetail', groupDetailComponent)

.name;

export default groupModule;



// WEBPACK FOOTER //
// ./client/app/components/group/group.js